import { useEffect, useState } from "react";
import { Button, Card, CardBody } from "reactstrap";
import PageLayout from "../layout/page";
import { useApi } from "../../helper/apiHook";
import { useApp } from "../../components/app";
import { SubscriptionView } from "../company/subscription";
import moment from "moment";

const Billing = () => {
  const app = useApp();
  const api: any = useApi("company", true, {}, {}, app.isLoading);
  const paymentApi = useApi("payment", false, {}, {}, true);
  const searchParams = new URLSearchParams(window.location.search);

  const [target, setTarget] = useState<{ companyId?: number; tenantId?: number } | null>(null);
  const [cancellingTenantId, setCancellingTenantId] = useState<number | null>(null);

  useEffect(() => {
    const companyId = searchParams.get("companyId");
    if (companyId) {
      setTarget({ companyId: Number(companyId) });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cancelAutoRenew = async (tenantDbId: number) => {
    setCancellingTenantId(tenantDbId);
    try {
      const result = await paymentApi.serverRequest({
        url: "/payment/cancel",
        requestType: "POST",
        isMutate: false,
        body: { tenantId: tenantDbId },
      });
      if (result?.status) {
        api.mutate();
      }
    } finally {
      setCancellingTenantId(null);
    }
  };

  return (
    <PageLayout
      title="Billing"
      View={
        <div className="billing-list">
          {api?.data?.map((company: any) => (
            <Card key={company.id} className="mb-3">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="m-0">{company.name}</h5>
                </div>
                {company.tenant.length === 0 && <p className="mb-0">No organisations connected yet.</p>}
                {company.tenant.map((tenant: any) => {
                  const activeSubscription = tenant.tenantSubscription?.[0];
                  const autoRenewActive =
                    !!activeSubscription?.razorpaySubscriptionId &&
                    activeSubscription?.paymentStatus === "paid";
                  const autoRenewCancelled =
                    !!activeSubscription?.razorpaySubscriptionId &&
                    activeSubscription?.paymentStatus === "cancelled";
                  return (
                    <div key={tenant.id} className="d-flex justify-content-between align-items-center py-2 border-top">
                      <div>
                        <b>{tenant.tenantName}</b>
                        <div>
                          {tenant.isSubscribe ? (
                            <span>
                              {activeSubscription?.plan?.name || "Subscribed"}
                              {activeSubscription?.expireAt
                                ? autoRenewActive
                                  ? ` — renews ${moment(activeSubscription.expireAt).format("DD/MM/YYYY")}`
                                  : ` — expires ${moment(activeSubscription.expireAt).format("DD/MM/YYYY")}`
                                : ""}
                              {autoRenewCancelled ? " (auto-renew cancelled)" : ""}
                            </span>
                          ) : (
                            <span>No active subscription</span>
                          )}
                        </div>
                      </div>
                      {app.currentApp?.appCode === "xero" && !tenant.isSubscribe && (
                        <Button
                          color="primary"
                          onClick={() => setTarget({ tenantId: tenant.id, companyId: company.id })}
                        >
                          Subscribe
                        </Button>
                      )}
                      {app.currentApp?.appCode === "xero" && tenant.isSubscribe && autoRenewActive && (
                        <Button
                          color="secondary"
                          outline
                          disabled={cancellingTenantId === tenant.id}
                          onClick={() => cancelAutoRenew(tenant.id)}
                        >
                          {cancellingTenantId === tenant.id ? "Cancelling..." : "Cancel auto-renew"}
                        </Button>
                      )}
                    </div>
                  );
                })}
              </CardBody>
            </Card>
          ))}
          {target && (
            <SubscriptionView
              subscription={!!target}
              PlanToggle={() => setTarget(null)}
              companyId={target.companyId}
              tenantId={target.tenantId}
              onSubscribed={() => {
                api.mutate();
                setTarget(null);
              }}
            />
          )}
        </div>
      }
    />
  );
};

export default Billing;
